// extracted by mini-css-extract-plugin
export default {"box":"styles_box__U+3xK","shimmer":"styles_shimmer__pYtP9"};